export const APPROVAL_SETTINGS_LOAD = 'APPROVAL_SETTINGS_LOAD';
export const APPROVAL_SETTINGS_LOAD_SUCCESS = 'APPROVAL_SETTINGS_LOAD_SUCCESS';
export const APPROVAL_SETTINGS_LOAD_ERROR = 'APPROVAL_SETTINGS_LOAD_ERROR';
export const APPROVAL_SETTINGS_ADD = 'APPROVAL_SETTINGS_ADD';
export const APPROVAL_SETTINGS_ADD_SUCCESS = 'APPROVAL_SETTINGS_ADD_SUCCESS';
export const APPROVAL_SETTINGS_ADD_ERROR = 'APPROVAL_SETTINGS_ADD_ERROR';
export const APPROVAL_SETTINGS_UPDATE = 'APPROVAL_SETTINGS_UPDATE';
export const APPROVAL_SETTINGS_UPDATE_SUCCESS = 'APPROVAL_SETTINGS_UPDATE_SUCCESS';
export const APPROVAL_SETTINGS_UPDATE_ERROR = 'APPROVAL_SETTINGS_UPDATE_ERROR';
export const APPROVAL_SETTINGS_DELETE = 'APPROVAL_SETTINGS_DELETE';
export const APPROVAL_SETTINGS_DELETE_SUCCESS = 'APPROVAL_SETTINGS_DELETE_SUCCESS';
export const APPROVAL_SETTINGS_DELETE_ERROR = 'APPROVAL_SETTINGS_DELETE_ERROR';
